var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_vm._v("Show this category if text of the parent is equal to "),_c('v-text-field',{attrs:{"hide-details":"","single-line":""},on:{"input":_vm.setConditions},model:{value:(_vm.existingCondition),callback:function ($$v) {_vm.existingCondition=$$v},expression:"existingCondition"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }